module.exports = __webpack_public_path__ + "static/media/cupcakeVanilla.918607c8.jpg";